(function BuceApprovedCartV2(){
 'use strict';
 if(window.BuceApprovedCartV2)return;
 window.BuceApprovedCartV2={version:'20261014-qa-visual'};
 const prefix='buce-approved-';
 const ns='http://www.w3.org/2000/svg';
 const icons={
  accessories:[['path','M7 3h10v9l3.5 3.8a3.2 3.2 0 0 1-2.5 5.2H5.8A3.8 3.8 0 0 1 2 17.2c0-1.8 1.6-3.3 3.5-4.8L7 11V3Z'],['path','M7 7h10']],
  shoes:[['path','M2 17h20v2.2c0 1-.8 1.8-1.8 1.8H3.8c-1 0-1.8-.8-1.8-1.8V17Z'],['path','M3 17l4-8.5 3.2 2L12 5l3 1.8-.4 5.2 4.6 2.3c1.5.7 2.5 1.5 2.8 2.7H3Z'],['path','m7.8 10.7 3.5 1.7m-1.7-3.9 3.1 1.5']],
  shirts:[['path','M9 3h1a2 2 0 0 0 4 0h1l6 3 2 5-4 2-2-3v11H7V10l-2 3-4-2 2-5 6-3Z']],
  tag:[['path','M20.5 12.5 12 21l-9-9V3h9l8.5 8.5a.7.7 0 0 1 0 1Z'],['circle','8,8,1.1']]
 };
 let frame=0,drawerObserver=null,watchedDrawer=null;
 function makeIcon(name,extraClass){
  const el=document.createElement('span');el.className=prefix+'icon'+(extraClass?' '+extraClass:'');el.setAttribute('aria-hidden','true');
  const svg=document.createElementNS(ns,'svg');svg.setAttribute('viewBox','0 0 24 24');
  svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.8');
  svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');svg.setAttribute('focusable','false');
  for(const [kind,data] of icons[name]||[]){
   const child=document.createElementNS(ns,kind);
   if(kind==='circle'){const [cx,cy,r]=data.split(',');child.setAttribute('cx',cx);child.setAttribute('cy',cy);child.setAttribute('r',r);}
   else child.setAttribute('d',data);
   svg.append(child);
  }
  el.append(svg);return el;
 }
 function decorateTabs(drawer){
  for(const button of drawer.querySelectorAll('.buce-cart-tabs button[data-buce-tab]')){
   if(button.querySelector('.'+prefix+'icon'))continue;
   const kind=button.dataset.buceTab;
   if(!icons[kind])continue;
   button.classList.add(prefix+'tab-'+kind);
   button.prepend(makeIcon(kind));
   const title=button.querySelector(':scope > span:not(.'+prefix+'icon)');
   if(title)title.classList.add(prefix+'tab-title');
   const badge=button.querySelector(':scope > small');
   if(badge){
    badge.classList.add(prefix+'size-badge');
    badge.textContent='de tu talla';
   }
  }
 }
 function decorateCards(drawer){
  // El carrusel usa exactamente una accion de compra por tarjeta.
  // Las opciones de color o talla permanecen como variantes Shopify nativas.
  for(const card of drawer.querySelectorAll('section[data-buce-cart-rail] article.buce-socks-nudge')){
   const button=card.querySelector('button[data-buce-cart-add]');
   if(button)button.classList.add(prefix+'add-button');
   // Retirar antiguos colores presentados como botones + que duplicaban controles.
   card.querySelectorAll('.'+prefix+'swatches').forEach(node=>node.remove());
   const select=card.querySelector('select[data-buce-cart-variant]');
   if(select&&select.classList.contains(prefix+'select-with-swatches')){
    select.classList.remove(prefix+'select-with-swatches');
    select.removeAttribute('aria-hidden');
    select.removeAttribute('tabindex');
   }
  }
 }
 function decorateProgress(drawer){
  const progress=drawer.querySelector('[data-buce-ah-progress]');
  if(!progress)return;
  let head=progress.querySelector(':scope > .'+prefix+'promo-head');
  if(!head){
   head=document.createElement('div');head.className=prefix+'promo-head';
   head.append(makeIcon('tag',prefix+'promo-icon'));
   const copy=document.createElement('div');copy.className=prefix+'promo-copy';
   const title=document.createElement('strong');title.className=prefix+'promo-title';
   title.textContent='Descuento sobre descuento';
   const stateLine=document.createElement('span');stateLine.className=prefix+'promo-state';
   stateLine.setAttribute('aria-live','polite');
   copy.append(title,stateLine);head.append(copy);
   progress.prepend(head);
  }
  const state=window.BuceAH&&typeof window.BuceAH.state==='function'?window.BuceAH.state():null;
  const pairs=Math.max(0,Number(state?.pairs??progress.dataset.level??0));
  const confirmed=state?.confirmed===true||(!state&&progress.dataset.confirmed==='true');
  const complete=pairs>=6&&confirmed;
  progress.dataset.buceApprovedGift=String(complete);
  const stateText=complete?'¡Par gratis aplicado!':pairs>=6?'Regalo por confirmar':'Suma pares y ahorra más';
  const label=head.querySelector('.'+prefix+'promo-state');
  if(label&&label.textContent!==stateText)label.textContent=stateText;
 }
 function render(){
  frame=0;
  const drawer=document.getElementById('t4s-mini_cart');
  if(!drawer)return;
  if(watchedDrawer!==drawer){
   if(drawerObserver)drawerObserver.disconnect();
   watchedDrawer=drawer;
   drawerObserver=new MutationObserver(function(changes){
    for(const change of changes){
     if(change.type!=='childList')continue;
     for(const node of change.addedNodes){
      if(node.nodeType!==1)continue;
      if(node.matches?.('.buce-cart-tabs,.buce-cart-complements,[data-buce-ah-progress],.buce-socks-nudge,[data-buce-v8-info]')
       ||node.querySelector?.('.buce-cart-tabs,.buce-cart-complements,[data-buce-ah-progress],.buce-socks-nudge,[data-buce-v8-info]')){
       schedule();return;
      }
     }
    }
   });
   drawerObserver.observe(drawer,{childList:true,subtree:true});
  }
  decorateTabs(drawer);
  decorateCards(drawer);
  decorateProgress(drawer);
 }
 function schedule(){
  if(frame)return;
  frame=requestAnimationFrame(render);
 }
 function start(){
  document.addEventListener('buce:cart-status',schedule);
  document.addEventListener('buce:ah-state',schedule);
  document.addEventListener('shopify:section:load',schedule);
  schedule();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

(function BuceCleanPurchase(){
 'use strict';
 if(window.BuceCleanPurchase)return;
 window.BuceCleanPurchase=true;
 function fold(input,copy){
  if(!input||input.closest('details.buce-clean-fold'))return;
  const label=input.labels&&input.labels[0];
  if(!label||label.parentElement!==input.parentElement)return;
  const nodes=[];let node=label;
  while(node){nodes.push(node);if(node===input)break;node=node.nextSibling;}
  if(nodes[nodes.length-1]!==input)return;
  const details=document.createElement('details');details.className='buce-clean-fold';
  const summary=document.createElement('summary');summary.textContent=copy;
  details.append(summary);label.before(details);nodes.forEach(n=>details.append(n));
  if(input.value.trim())details.open=true;
 }
 function enhance(){
  const main=document.getElementById('MainContent');if(!main)return;
  const media=main.querySelector('.t4s-product__media-wrapper');
  const size=main.querySelector('.t4s-swatch__option.is-t4s-name__talla');
  if(media&&size&&!media.querySelector('.buce-clean-jump')){
   const row=document.createElement('div');row.className='buce-clean-jump';
   
   const button=document.createElement('button');button.type='button';button.textContent='Elegir talla ↓';
   button.addEventListener('click',()=>{
    size.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    size.querySelector('[role="button"][aria-disabled="false"]')?.focus({preventScroll:true});
   });
   row.append(button);const benefits=media.querySelector('.buce-feedback-benefits');if(benefits)benefits.append(row);else media.prepend(row);
  }
  const guide=main.querySelector('.buce-size-guide');
  if(guide&&!guide.querySelector('.buce-clean-fold')){
   const details=document.createElement('details');details.className='buce-clean-fold';
   const summary=document.createElement('summary');summary.textContent='Guía de tallas';
   details.append(summary);while(guide.firstChild)details.append(guide.firstChild);guide.append(details);
  }
  const goal=main.querySelector('[data-ah-goal]');
  if(goal&&goal.textContent!=='Más pares, más ahorro')goal.textContent='Más pares, más ahorro';
  const progress=main.querySelector('[data-buce-ah-progress][data-confirmed="true"][data-level="1"]');
  const next=progress?.querySelector('[data-ah-next]');
  if(next&&next.textContent!=='Otro par, $15.000 de ahorro extra')next.textContent='Otro par, $15.000 de ahorro extra';
  fold(main.querySelector('#CartSpecialInstructions'),'Añadir una nota');
  fold(main.querySelector('#CartDiscountcode'),'Tengo un código');
 }
 document.addEventListener('buce:cart-status',()=>requestAnimationFrame(enhance));
 document.addEventListener('shopify:section:load',enhance);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
})();

(function BuceSearchTouch(){
 'use strict';
 document.addEventListener('click',function(event){
  var field=event.target.closest('#t4s-search-hidden .t4s-mini-search__btns');
  if(!field||event.target.closest('button,input'))return;
  var input=field.querySelector('[data-input-search]');
  if(input)input.focus({preventScroll:true});
 });
})();

(function BuceSearchField(){
 'use strict';
 function enhance(){
  var root=document.getElementById('t4s-search-hidden'),input=root&&root.querySelector('[data-input-search]'),box=input&&input.closest('.t4s-mini-search__btns');
  if(!box||box.dataset.buceSearchField==='true')return;
  box.dataset.buceSearchField='true';
  input.type='search';input.setAttribute('enterkeyhint','search');
  if(!input.hasAttribute('aria-label'))input.setAttribute('aria-label',input.placeholder.replace(/\.+$/,''));
  var submit=box.querySelector('[data-submit-search]');if(submit)submit.classList.remove('t4s-pe-none');
  if(!box.querySelector('.buce-search-field-icon')){
   var ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg');
   svg.setAttribute('class','buce-search-field-icon');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.8');svg.setAttribute('aria-hidden','true');
   var circle=document.createElementNS(ns,'circle');circle.setAttribute('cx','10.5');circle.setAttribute('cy','10.5');circle.setAttribute('r','7');
   var path=document.createElementNS(ns,'path');path.setAttribute('d','m16 16 4.5 4.5');svg.append(circle,path);box.prepend(svg);
  }
 }
 enhance();document.addEventListener('DOMContentLoaded',enhance);
 new MutationObserver(enhance).observe(document.body,{childList:true,subtree:true});
})();
